import { createSlice } from '@reduxjs/toolkit';
import { getApplication } from 'shared/redux/applicationSlice';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';

const initialState = {
  consent: null,
  stamp: null,
  accepted: false,
};

const plantDesignDeclarationSlice = createSlice({
  name: 'plantDesignDeclaration',
  initialState,
  reducers: {
    storePlantDesignDeclaration(state, action) {
      state.accepted = true;
      state.consent = action.payload.consent;
      state.stamp = action.payload.stamp;
    },
    clearPlantDesignDeclaration(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantDesignDeclaration };
      });
  },
});

export const { storePlantDesignDeclaration, clearPlantDesignDeclaration } = plantDesignDeclarationSlice.actions;
export const plantDesignDeclarationReducer = plantDesignDeclarationSlice.reducer;
